<template>{{ rawText }}</template>
<script>
export default {
  props: {
    rawText: { type: String, default: "" },
  },
};
</script>
